// Charte graphique des documents (Ordre 18 bis) — what the charte page needs besides the server's answers.
export const BRAND_COLOR_KEYS = ["primary", "secondary", "soft", "border", "text", "muted"];

const HEX = /^#[0-9a-fA-F]{6}$/;

export function isHexColor(value) {
  return typeof value === "string" && HEX.test(value);
}

// The sample line under a font selector: the title and the body of a contract, in the chosen letters.
export function brandSample(slot) {
  return slot === "headings" ? "Contrat de prestation — Article 1" : "Le présent contrat définit les conditions d'accès à Jamora.";
}

// Has the form moved away from what is saved? Order of keys never matters.
export function sameBrand(a, b) {
  const norm = (brand) => JSON.stringify({
    colors: BRAND_COLOR_KEYS.map((k) => String(brand.colors[k]).toLowerCase()), fonts: [brand.fonts.body, brand.fonts.headings], size: Number(brand.base_size),
    margins: [brand.margins.top, brand.margins.side, brand.margins.bottom].map(Number), numbering: brand.numbering,
    logo: brand.logo_asset_id || null, stamp: brand.stamp_asset_id || null,
  });
  return norm(a) === norm(b);
}
